import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalysis = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.805 15.805c-.13.13-.301.195-.471.195s-.341-.065-.471-.195l-3.979-3.979c-1.15.941-2.618 1.508-4.216 1.508C2.991 13.333 0 10.343 0 6.667S2.991 0 6.667 0a6.67 6.67 0 0 1 3.334.892c.319.185.428.593.243.911-.123.213-.347.333-.577.333-.113 0-.228-.029-.333-.089-.806-.467-1.728-.713-2.666-.713a5.34 5.34 0 0 0-5.333 5.333c0 .778.171 1.516.473 2.183L4.339 5.81a1.35 1.35 0 0 1 .975-.484c.375-.017.748.125 1.016.394l1.285 1.285L13.491.227c.241-.279.663-.308.94-.069s.31.662.069.941L8.647 7.876c-.244.283-.598.453-.972.467s-.739-.13-1.003-.395L5.387 6.663l-2.842 3.383c.979 1.192 2.463 1.953 4.122 1.953A5.34 5.34 0 0 0 12 6.666l-.009-.298a.67.67 0 0 1 .631-.701c.365-.027.681.263.701.63l.01.369a6.63 6.63 0 0 1-1.508 4.216l3.979 3.979c.261.261.261.682 0 .943v.001z",
			fill: "#333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgAnalysis;
